import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const FLOW = ["Placed", "Accepted", "Weaving", "Ready", "Dispatched", "Delivered"];

export function LiveTracker({ orderNumber }) {
  const [t, setT] = useState(null);

  useEffect(() => {
    const load = () => api.get(`/track/${orderNumber}`).then((r) => setT(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, [orderNumber]);

  if (!t) return null;
  const reached = Math.max(0, FLOW.indexOf(t.public_status));
  const atOf = (s) => t.steps.filter((x) => x.status === s).pop()?.at;

  return (
    <div className="mt-10 text-left max-w-md mx-auto rounded-sm border border-[#D4AF37]/20 bg-[#14110E]/80 p-6" data-testid="live-tracker">
      <div className="flex items-center justify-between">
        <p className="font-display text-lg">Live order status</p>
        <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-emerald-400"><span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" /> live</span>
      </div>
      <p className="text-xs text-[#6E6558] mt-1">Updates appear here as soon as the admin confirms them.</p>
      <ol className="mt-5 space-y-3">
        {FLOW.map((s, i) => (
          <li key={s} className="flex items-center gap-3" data-testid={`tracker-step-${s.toLowerCase()}`}>
            <span className={`h-6 w-6 rounded-full grid place-items-center border ${i <= reached ? "bg-[#D4AF37] border-[#D4AF37] text-[#0B0907]" : "border-[#D4AF37]/25 text-transparent"}`}><Check className="h-3.5 w-3.5" /></span>
            <span className={`text-sm ${i <= reached ? "text-[#F5EFE6]" : "text-[#6E6558]"}`}>{s}</span>
            {i <= reached && atOf(s) && <span className="ml-auto text-[11px] text-[#6E6558]">{fmtDate(atOf(s))}</span>}
          </li>
        ))}
      </ol>
      {t.public_status === "Cancelled" && <p className="text-sm text-[#E06D3B] mt-4">This order was cancelled.</p>}
    </div>
  );
}
